// import { useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useSelector, shallowEqual } from 'react-redux';

import { config } from 'config';
// import { socket } from 'api';
// import { ToClip } from '../to-clip/to-clip';
import { Loader } from '../loader/loader';
import { Tooltip } from '../tooltip/tooltip';
import { Content, Title, InfoRow, Info } from './payment-mean.styled';
import { List } from './list';

// {
//     "is_mean_blocked": false,
//     "payment_mean_id": "100-74859302856",
//     "payment_mean_number": null,
//     "payment_mean_type": "subscription",
//     "stay": {
//         "amount": 2227000,
//         "entry_at": "2026-05-22T16:13:04",
//         "is_secondentry": false,
//         "stay_id": "32b8f9d03987460a90716d97966846e3",
//         "vehicle_class": 1,
//         "vehicle_plate": "P668PT68"
//     },
//     "tariff_id": "d1f925d040a34342a27e5bdb3fbde614",
//     "tariff_name": "Базовый, класс 1",
//     "vehicle_class": 1,
//     "vehicle_plate": null
// }

export const PaymentMean = (props) => {
  const { id } = props;
  const loading = false;
  const { t } = useTranslation();
  const info = useSelector((store) => store.equipment[id]?.payment_mean ?? null, shallowEqual);
  // console.log('🚀 ~ PaymentMean ~ info:', info);

  // const [info, setInfo] = useState(null);
  // const [loading, setLoading] = useState(true);

  const vehicleClasses = {
    1: t('vehicleClass.Легковые автомобили'),
    2: t('vehicleClass.Микроавтобусы / газели'),
    3: t('vehicleClass.Грузовики / автобусы'),
    4: t('vehicleClass.Спецтранспорт (с прицепом)'),
  };

  const types = {
    subscription: t('means.Абонемент'),
    receipt: t('means.Билет'),
    bank_card: t('means.Банковская карта'),
    card: t('means.БСК'),
    rfid: t('means.RFID'),
    vehicle_plate: t('means.ГРЗ'),
    plate: t('means.ГРЗ'),
  };

  //   {
  //     "is_mean_blocked": false,
  //     "payment_mean_id": "95232000860",
  //     "payment_mean_number": "860",
  //     "payment_mean_type": "receipt",
  //     "stay": null,
  //     "vehicle_class": 1,
  //     "vehicle_plate": "B310OP59"
  // }

  // get data
  // useEffect(() => {
  //   let _mounted = true;

  //   const onGetPaymentMean = (data) => {
  //     if (_mounted) {
  //       setInfo(data.payment_mean);
  //       setLoading(false);
  //     }
  //   };

  //   setLoading(true);
  //   sendControlMsg('get_payment_mean');
  //   socket.on('get_payment_mean', onGetPaymentMean);

  //   return () => {
  //     _mounted = false;
  //     socket.off('get_payment_mean', onGetPaymentMean);
  //   };
  // }, []);

  /**
   * get payment mean type
   * @returns
   */
  const getPaymentMeanType = (info) => {
    if (!info) {
      return '';
    }

    if (types[info.payment_mean_type]) {
      return types[info.payment_mean_type];
    }
    return info.payment_mean_type || t('means.Не определено');
  };

  /**
   * get vehicle clas
   * @param {*} class_id
   * @returns
   */
  const getVehicleClass = (class_id) => {
    if (vehicleClasses[class_id]) {
      return vehicleClasses[class_id];
    }
    return class_id;
  };

  const getTooltip = (stay, value) => {
    if (!stay || !stay.stay_id) {
      return value;
    }

    const link = (config.crm_url ?? '/crm') + '/card/stay?id=' + stay.stay_id;
    return (
      <Tooltip info="Перейти в карточку парковочной сессии" asIcon={false} top={'30px'} width={'340px'}>
        <a href={link} target="_blank" rel="noopener">
          {value}
        </a>
      </Tooltip>
    );
  };

  const getTariffTooltip = (tariff_id, name) => {
    const link = (config.crm_url ?? '/crm') + '/card/tariff?id=' + tariff_id;
    return (
      <Tooltip info="Перейти в карточку тарифа" asIcon={false} top={'30px'} width={'340px'}>
        <a href={link} target="_blank" rel="noopener">
          {name}
        </a>
      </Tooltip>
    );
  };

  const getItems = () => {
    // get items
    const out = [];
    const stay = info.stay;
    const type = getPaymentMeanType(info);
    // console.log('info', type, info.payment_mean_number);
    // plate
    if (info.vehicle_plate) {
      let value = info.vehicle_plate;
      if (!type || (!info.payment_mean_number && !info.payment_mean_id)) {
        value = getTooltip(stay, value);
      }
      out.push({ name: t('means.ГРЗ'), value, withCopy: true });
    }

    // mean type and number
    // const isDoublePlate = info.payment_mean_type === 'vehicle_plate' && !!info.vehicle_plate;
    // if (!isDoublePlate) {
    if (type) {
      let value = type;
      let ok = false;
      if (info.payment_mean_number) {
        value += ' ' + info.payment_mean_number;
        ok = true;
      } else if (info.payment_mean_id) {
        value += ' ' + info.payment_mean_id;
        ok = true;
      }
      if (ok) {
        value = getTooltip(stay, value);
      }
      out.push({ name: t('means.Идентификатор'), value });
    }
    // }

    // blocked
    if (info.is_mean_blocked) {
      const isPlate = info?.payment_mean_type === 'vehicle_plate';
      const title = isPlate ? 'windows.ГРЗ в чёрном списке' : 'windows.СО блокировано';
      out.push({
        cmp: (
          <InfoRow>
            <p>
              <img src="/images/warning.png" alt="" width={22} />
            </p>
            <span>{t(title)}</span>
          </InfoRow>
        ),
      });
    }

    // class
    out.push({ name: t('windows.Класс'), value: getVehicleClass(info.vehicle_class) });

    // tariff
    if (info.tariff_name) {
      const value = getTariffTooltip(info.tariff_id, info.tariff_name);
      out.push({ name: t('forms.Тариф'), value });
    }

    // stay info
    if (stay && stay.stay_id) {
      if (stay.entry_at) {
        out.push({ name: t('windows.Время вьезда'), value: moment(stay.entry_at).format('lll') });
      }
      // secondary entry
      if (stay.is_secondentry) {
        out.push({
          cmp: (
            <InfoRow>
              <div>{t('windows.Повторный въезд')}</div>
            </InfoRow>
          ),
        });
      }
      if (stay.amount) {
        out.push({ name: t('windows.К оплате'), value: stay.amount / 100 + ' р.' });
      }
    }

    return out;
  };

  const items = !loading && info ? getItems() : null;

  return (
    <Content>
      {/* <ToClip value="123" title="test" /> */}
      <Title>
        {t('buttons.Подробности')} {loading && <Loader />}
      </Title>
      {!loading && <>{info ? <List items={items} /> : <Info>{t('messages.Нет данных по средству оплаты')}</Info>}</>}
    </Content>
  );
};
